import React from "react";
import logo from "../images/fmm-logo-black@2x.png"
import logoMobile from "../images/find-my-mission-logo-white.png"
import { Link } from "wouter";
import ApplicantsCounter from "../components/ApplicantsCounter";
import CommunityMeta from "../components/CommunityMeta";
import SendMeButton from "../components/SendMeButton";
import PoweredByImg from "../images/powered-by-the-send-black@2x.png"

export default function SingleCommunity({id, communities, email}) {
      
      const thisCommunity = communities.find(function(e) {
            return e.id == id;
      })?.attributes;

      if(thisCommunity == null){
            return(
                  <div>Oh no... We can't find that page. Try returning <a style={{textDecoration:"underline"}} href="/">home</a></div>
            )
      }

      if(communities.length==0){
            return(
                  <div>Loading data...</div>
            )
      }

      const xlargeurl = thisCommunity.banner.data?.attributes.formats.xlarge?.url;
      var communityImage = thisCommunity.banner.data?.attributes.url;
      if (xlargeurl){communityImage = xlargeurl}
      if (!communityImage.startsWith("http") ){communityImage = process.env.REACT_APP_BACKEND + communityImage}
      const videoUrl = thisCommunity.video.data?.attributes.url;
      const hubspotId = thisCommunity.slug;
      var firstClick = true;

      const months = thisCommunity.semesters.map(
            (semester) => {
                const start = semester.start_date
                //const start = "2023-10-01"
                const month = new Date(start).toLocaleDateString('en-GB',{ month: 'short' });
                //const  = start.date.toLocaleString('default', { month: 'long' });
                
                return month;
            }
        );
        
        const monthsString = months.join(', ').replace(/, ([^,]*)$/, ' & $1')

      



      function playPauseVideo() {
            
            var video=document.getElementById("myVideo");
            var playButton = document.getElementById("play-button");

            if(firstClick){
                  video.currentTime = 0;
                  playButton.classList.add("hide");
                  video.muted = false;
                  video.loop = false;
                  
                  video.play();

                  firstClick = false;
            }else{
                  // I wrapped this logic in an else because on safari it was pausing the video cause it saw that it was playing already.
                  if (!video.paused && !video.ended && video.readyState > 2){
                        video.pause();
                        playButton.classList.remove("hide");
                  }else{
                        video.play(); 
                        playButton.classList.add("hide");
                  }
            }
      }


      console.log(thisCommunity)

    return (
      <div id={'community-'+thisCommunity.slug} className="page page-single-community v-center">
            <div className="container content" >
            <div className="row back-desktop-row">
                  <div className="col back-link-col">
                        <Link href={`/`}>
                              <a className="link back-to-communities">&#60; Browse Top Picks</a>
                        </Link>
                  </div>
            </div>
            <div className="row content-row">
                  <div className="col video-col">
                        {videoUrl &&
                              <div className="video-wrapper">
                                    <video onClick={playPauseVideo} id="myVideo" className="community-video" poster="" width="320" height="240" autoPlay playsInline muted loop>
                                          <source src={videoUrl} type="video/mp4"/>
                                    Your browser does not support the video tag.
                                    </video>
                                    <div id="play-button" className="play-button" onClick={playPauseVideo}>
                                          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="30" viewBox="0 0 26 30">
                                                <path d="M13.268,3a2,2,0,0,1,3.465,0L28.27,23a2,2,0,0,1-1.732,3H3.463A2,2,0,0,1,1.73,23Z" transform="translate(27) rotate(90)"/>
                                          </svg>

                                    </div>
                              </div>
                        }
                        {!videoUrl && communityImage &&
                              <div className="video-wrapper">
                                    <img className="community-image" style={{objectPosition: thisCommunity.horizontalFocalPoint + '% center'}} src={communityImage} />
                                    <div className="single-community-bg-image-overlay"></div>
                              </div>
                        }
                  </div>
                  <div className="col main">
                        <div className="section">
                              <header className="App-header">
                                    <div className="logos-wrapper">
                                          <div className="back-mobile">
                                          <Link href={`/`}>
                                                <a className="link">
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="22.647" height="16.9" viewBox="0 0 22.647 16.9" fill="none" stroke="#fff" strokeLinecap="round" strokeWidth="2">
                                                            <line id="Line_1" x2="20.236" transform="translate(1 8.45)" />
                                                            <line id="Line_2" x2="7.918" y2="7.038" transform="translate(13.317 1.412)"/>
                                                            <line id="Line_3" y1="7.038" x2="7.918" transform="translate(13.317 8.45)"/>
                                                      </svg>
                                                </a>
                                          </Link>

                                          </div>
                                          <img className="logo logo-desktop hide-below-tablet" src={logo}></img>
                                          <img className="powered-by-single hide-below-tablet" src={PoweredByImg}></img>

                                          <img className="logo logo-mobile mobile-only" src={logoMobile}></img>
                                    </div>
                              </header>
                              <div className="community-top-stats">
                                    <div className="row community-title-row">
                                          <h3 className="community-name uppercase">{thisCommunity.title}</h3>
                                          <div className="single-affiliation-wrapper">
                                                <div className="single-affiliation-label">
                                                      AFFILIATION:
                                                </div>
                                                <div className="single-affiliation">
                                                      {thisCommunity.affiliation}
                                                </div>
                                          </div>
                                    </div>
                                    <div className="row top-stats-sub-wrapper">
                                          <div className="top-stat">
                                                <div className="top-stat-label">Training Location:</div>
                                                <div className="top-stat-text">
                                                      <span className="meta-icon">
                                                      <svg xmlns="http://www.w3.org/2000/svg" width="16.327" height="17.811" viewBox="0 0 16.327 17.811">
                                                            <path id="Path_3" data-name="Path 3" d="M13.987,1.484a1.9,1.9,0,0,1,1.855,1.806c0,1.008-.775,2.451-1.855,4.247-1.081-1.8-1.855-3.239-1.855-4.247a1.9,1.9,0,0,1,1.855-1.806Zm0-1.484a3.376,3.376,0,0,0-3.34,3.291c0,1.818,1.448,3.987,3.34,7.1,1.892-3.112,3.34-5.281,3.34-7.1A3.376,3.376,0,0,0,13.987,0Zm0,4.453A1.113,1.113,0,1,1,15.1,3.34,1.114,1.114,0,0,1,13.987,4.453ZM8.6,5.371c0-.007-.214-.013-.178-.058l.1-.063a.26.26,0,0,0-.006-.226l.035-.093-.074.022s.1-.45.245-.246l-.059.069a1.039,1.039,0,0,1,.145.462c.085.045.219.053.065.13.079-.013-.416.212-.481.119C8.344,5.431,8.607,5.393,8.6,5.371Zm-.531-.118c-.058.058,0,.095.061.07.084-.037.2-.036.21-.15l.055-.068c.023-.036-.046-.094-.076-.1s-.074.047-.1.071l-.049.013-.046.059.006.033Zm5.195,6.8-.545-.895-.537-.88c-.542-.886-1.031-1.689-1.455-2.446l-.052.05c-.28.116-.7-.378-.994-.394.143.022.013-.364.013-.389-.113-.14-.833.016-1.022.041a1.908,1.908,0,0,0-1,.263c-.191.156-.194.409-.39.531-.126.079-.263.053-.373.155a2.448,2.448,0,0,0-.517.689c-.045.1.058.34.032.469a1.482,1.482,0,0,0,1.02,2c.232.029.474.155.709.085a2.637,2.637,0,0,1,.554-.2c.28-.019.163.393.546.281.187-.055.271.128.271.266-.062.29-.2.452.065.655a.9.9,0,0,1,.361.579c.02.135.146.367-.01.447-.111.056-.193.376-.191.482.023.122.271.357.347.461.108.148.029.324.117.492a3.941,3.941,0,0,1,.239.479c.082.24.712-.005.858,0,.5,0,.753-.7,1.1-.917.2-.122.142-.457.378-.629.219-.16.45-.255.471-.55.016-.255-.191-.788-.077-1l.076-.122ZM7.845,6.3a2.069,2.069,0,0,1-.114.59c-.023.1.329.168.309.219,0-.006.476-.163.523-.2l.106-.24a1.328,1.328,0,0,1,.286-.145l.122-.212a3.468,3.468,0,0,1,.561-.075,1.842,1.842,0,0,1,.432.394l.03.024a11.341,11.341,0,0,1-.59-1.441l-.062.027a.87.87,0,0,0-.491.3,1.832,1.832,0,0,1-.543.245c.245.026.233.2.213.358C8.575,6.49,7.813,6.163,7.845,6.3Zm8.092,3.747a6.789,6.789,0,0,1-11.687,4.3c-.146-.154-.257-.519-.015-.668l.246-.063c.191-.163-.18-.824-.033-.931.458-.327.24-.729-.041-1.06-.119-.141-.774-.816-.848-.7a1.524,1.524,0,0,0-.223-.807,3.465,3.465,0,0,1-.5-.8C2.8,9.187,2.8,8.795,2.719,8.7c-.03-.037-.266-.137-.258-.191A6.773,6.773,0,0,1,4.216,4.987l.608-.245c.383-.574.4-.128.748-.278.114,0,.246-.471.368-.545.214-.137.05-.137.012-.2a4.523,4.523,0,0,1,1.82-.7c.024.1-.928.6-.823.585-.241.032-.287.465-.243.464.12,0,.877-.574,1.229-.453s.965-.275,1.207-.475l.031-.029A4.606,4.606,0,0,1,9.53,1.5l-.367-.019a8.159,8.159,0,1,0,7.995,6.509c-.364.641-.774,1.32-1.222,2.05Z" transform="translate(-1)"/>
                                                            </svg>
                                                      </span>
                                                      <span>
                                                            {thisCommunity.training_location}
                                                      </span>
                                                </div>
                                                            
                                          </div>
                                          <div className="top-stat">
                                                <div className="top-stat-label">Primary Focus:</div>
                                                <div className="top-stat-text">
                                                      <span className="meta-icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="19.689" height="16.407" viewBox="0 0 19.689 16.407">
                                                                  <path id="Path_13" data-name="Path 13" d="M4.922,10.2A3.272,3.272,0,0,0,11.3,11.242l1.825-1.059V10.2a4.931,4.931,0,1,1-2.482-4.271L8.831,6.985A3.269,3.269,0,0,0,4.922,10.2ZM8.2,8.563A1.641,1.641,0,1,0,9.844,10.2l0-.012,2.756-1.6a3.729,3.729,0,0,1,3.044.13l4.045-2.349L17.1,5.086l.139-2.98L13.18,4.461a3.737,3.737,0,0,1-1.4,2.708L9.006,8.78a1.632,1.632,0,0,0-.8-.217Zm6.559,1.568,0,.073a6.585,6.585,0,1,1-3.248-5.655,2.207,2.207,0,0,0,.12-1.788,8.2,8.2,0,1,0,4.734,8.147,1.74,1.74,0,0,0-1.61-.777Z" transform="translate(0 -2)"/>
                                                            </svg>
                                                      </span>
                                                      <span>
                                                      {thisCommunity.missions_focus}
                                                      </span>
                                                </div>
                                          </div>
                                          <div className="top-stat">
                                                <div className="top-stat-label">Signup Dates:</div>
                                                <div className="top-stat-text">
                                                      <span className="meta-icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path d="M20 20h-4v-4h4v4zm-6-10h-4v4h4v-4zm6 0h-4v4h4v-4zm-12 6h-4v4h4v-4zm6 0h-4v4h4v-4zm-6-6h-4v4h4v-4zm16-8v22h-24v-22h3v1c0 1.103.897 2 2 2s2-.897 2-2v-1h10v1c0 1.103.897 2 2 2s2-.897 2-2v-1h3zm-2 6h-20v14h20v-14zm-2-7c0-.552-.447-1-1-1s-1 .448-1 1v2c0 .552.447 1 1 1s1-.448 1-1v-2zm-14 2c0 .552-.447 1-1 1s-1-.448-1-1v-2c0-.552.447-1 1-1s1 .448 1 1v2z"/></svg>
                                                      </span>
                                                      <span>
                                                            {monthsString}
                                                      </span>
                                                </div>
                                          </div>
                                          
                                    </div>
                              </div>
                              <div className="community__info">
                                    <p className="community--desc">{thisCommunity.description}</p>
                                    <ApplicantsCounter bucket={thisCommunity.bucket} community={thisCommunity} />
                                    <div className="meta-button-wrapper">
                                          <CommunityMeta community={thisCommunity} />
                                          <SendMeButton btnText={'Send Me'} email={email} hubspotId={hubspotId} id={id} />
                                    </div>
                              </div>
                              
                        
                        </div>
                  </div>
            </div>
      </div>
    </div>
    );
  }